import PropTypes from "prop-types";
import React from "react";
import Swiper, { SwiperSlide } from "../../components/swiper";
import BrandLogoOneSingle from "../../components/brand-logo/BrandLogoOneSingle";
import brandLogoData from "../../data/brand-logos/brand-logo-one.json";
import SectionTitleSeven from "../../components/section-title/SectionTitleSeven";

const settings = {
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false
  },
  grabCursor: true,
  breakpoints: {
    1024: {
      slidesPerView: 5
    },
    768: {
      slidesPerView: 4
    },
    640: {
      slidesPerView: 3
    },
    320: {
      slidesPerView: 2
    }
  }
};

const BrandLogoSliderThree = ({ block }) => {

  return (
    <div
      className={`brand-logo-area ${
        block.spaceBottomClass ? block.spaceBottomClass : ""
      }  ${block.spaceTopClass ? block.spaceTopClass : ""}`}
    >
      <div className="container">
        <SectionTitleSeven
          titleText={block.title}
          positionClass="text-center"
          spaceClass="mb-50"
          borderClass="no-border"
        />
        <div className="brand-logo-active">
          <Swiper options={settings}>
            {block?.componentData?.map((single, key) => {
                return (
                  <SwiperSlide key={key}>
                  <BrandLogoOneSingle
                    data={single}
                    key={key}
                    sliderClassName="swiper-slide"
                    spaceBottomClass="mb-30"
                  />
                  </SwiperSlide>
                );
              })}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

BrandLogoSliderThree.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default BrandLogoSliderThree;
